module.exports = __webpack_public_path__ + "static/media/IMG_8842.d0ad2ab1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/horizontal/IMG_8842.jpg
// module id = 155
// module chunks = 0